<template>
  <div>
    <baseFrame
      clearText=""
      submitText="提交"
      :saveText="saveText"
      :saveLoading="saveLoading"
      :submitLoading="submitLoading"
      @save="save"
      @submit="save(true)"
      @cancel="$router.push({ name: 'supplierRefund'})">
      <div slot="content">
        <lk-card title="退货单信息">
          <lk-form ref="refundForm" :model="formModel" :rules="formRules" :label-width="134" label-position="right">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="供应商名称:" prop="supplierStoreId">
                  <lk-select @on-change="handleSupplierChange" filterable v-model.number="formModel.supplierStoreId">
                    <lk-option
                      v-for="(item, index) in supplierList"
                      :key="index"
                      :value="item.supplierId">{{item.supplierName}}</lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="来源:" prop="purchaseType">
                  <lk-select class="item" v-model="formModel.purchaseType" @on-change="handlePurchaseTypeChange">
                    <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="总金额:">
                  <span v-if="formModel.amount">{{formModel.amount}}</span>
                  <span v-else>系统自动生成</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="23">
                <lk-form-item label="退回商品:">
                  <div class="mb16">
                    <lk-button type="primary" @click="handleAdd" :disabled="!formModel.supplierStoreId">选择商品</lk-button>
                  </div>
                  <div class="FormatTable">
                    <lk-table border :columns="columns" :data="tableData" class="plan-table"/>
                  </div>
                </lk-form-item>
              </lk-col>
              <lk-col span="7">
                <lk-form-item label="退货原因:" prop="remark">
                  <lk-input
                    type="textarea"
                    placeholder="请输入"
                    v-model.trim="formModel.remark"
                    :rows="6"
                    :maxlength="100">
                  </lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <lk-modal
      width="900"
      title="添加商品"
      v-model="addGoods"
      :mask-closable="false"
      @on-cancel="handleModalCancel">
        <div class="queryContainer">
          <div class="queryItem">
            <label>商品搜索：</label>
            <lk-input
              :maxlength="100"
              v-model.trim="queryParams.nameMix"
              class="item"
              placeholder="可按商品名、通用名、助记码、商品编码筛选">
            </lk-input>
          </div>
          <div class="queryItem">
            <label>验收时间：</label>
            <timeStampDatePicker  class="item" v-model="queryParams.inspectionTime"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr8" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clearQueryParams">重置</lk-button>
          </div>
      </div>
      <div class="addContainer">
        <loading v-show="loading"></loading>
        <lk-table
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          border
          height="450"
          :columns="goodsColumns"
          :data="goodsData">
        </lk-table>
        <div style="margin-top: 14px; text-align: right;">
          <lk-page
            :total="goodsPage.count"
            :page-size="goodsPage.size"
            size="small"
            show-sizer
            show-elevator
            @on-change="handleGoodsPage"
            @on-page-size-change="handleGoodsSize">
          </lk-page>
        </div>
      </div>
      <div slot="footer">
        <!-- <span class="mr8">已选： {{tempGoodsList.length}}项</span> -->
        <lk-button @click="handleModalCancel">取消</lk-button>
        <lk-button @click="confirmGoods" type="primary">确定</lk-button>
      </div>
    </lk-modal>

    <DTPModal
      v-model="changeSupplier"
      content="一旦更改供应商名称，将清空已添加的退回商品明细，是否继续？"
      @confirm="doChangeSupplier"
      @handleCancel="cancelChangeSupplier">
    </DTPModal>
    <DTPModal
      v-model="changePurchaseType"
      content="一旦更改来源，将清空已添加的退回商品明细，是否继续？"
      @confirm="doChangePurchaseType"
      @handleCancel="cancelChangePurchaseType">
    </DTPModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import refund from '../../services/refund';
// import AnTable from '../../components/table';
import loading from '../../components/LoadingSpan';
import DTPModal from '../../components/DTPModal';
import DtpInputNumber from '../../components/DtpInputNumber';

export default {
  name: 'supplierRefundForm',
  components: {
    baseFrame,
    // AnTable,
	  loading,
    DTPModal,
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
    ]),
    selectedGoodsIds() { // 选中的明细
      const result = [];
      this.tableData.forEach((item) => {
        result.push(item.inventoryId);
      });
      return result;
    },
    selectedTempGoodsIds() { // 临时选中的明细
      const result = [];
      this.tempGoodsList.forEach((item) => {
        result.push(item.inventoryId);
      });
      return result;
    },
  },
  data() {
    return {
      queryParams: {
        supplierId: '', // 供应商id
        nameMix: '', // 商品搜索
        // approvedDrugName: '', // 商品通用名
        inspectionTime: null, // 验收时间
      },
      goodsParams: {},
      tempSupplier: '',
      tempPurchaseType: 1, // 默认来源为普通商品
      changeSupplier: false,
      changePurchaseType: false,
      addGoods: false,
		  loading: false,
      formModel: {
        supplierStoreId: null,
        purchaseType: 1, // 来源
        remark: '',
        purchaseRefundDetailList: [],
        amount: 0, // 本地计算的总数 不传递到后台
      },
      formRules: {
        supplierStoreId: [
          {
            required: true,
            message: '请选择供应商！',
          },
        ],
        purchaseType: [
          {
            required: true,
            message: '请选择来源！',
          },
        ],
        remark: [
          {
            required: true,
            message: '请输入退货原因！',
          },
          { // 100字符，必需有汉字
            validator(rule, value, callback) {
              if (/^[\w\W]*[\u4e00-\u9fa5]+[\w\W]*$/.test(value)) {
                callback();
              } else {
                callback(new Error('退货原因必须有汉字！'));
              }
            },
          },
          {
            min: 1,
            max: 100,
            message: '请输入1-100之内的字符，且必须有汉字！',
          },
        ],
      },
      tableData: [],
      tempGoodsList: [],
      goodsData: [],
      goodsColumns: [
        {
          title: '选择',
          key: 'id',
          type: 'selection',
          width: 60,
        },
        { title: '验收单号', key: 'inspectionCode', minWidth: 116 },
        { title: '商品通用名', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '批号', key: 'batchCode', minWidth: 116 },
        { title: '包装单位', key: 'minPkgUnitName', minWidth: 116 },
        { title: '可退货数量', key: 'inventoryNum', minWidth: 116 },
        { title: '原验收数量', key: 'inspectionPassNum', minWidth: 116 },
        { title: '单价', key: 'priceWithTax', minWidth: 116 },
        { title: '验货时间', key: 'inspectionTime', minWidth: 116 },
      ],
      goodsPage: {
        page: 1,
        size: 10,
        count: 0,
      },
      columns: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        { title: '验收单号', key: 'inspectionCode', minWidth: 116 },
        { title: '入库时间', key: 'purchaseTime', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '商品通用名', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '批号', key: 'batchCode', minWidth: 116 },
        { title: '有效期', key: 'expiryDate', minWidth: 116 },
        { title: '原验收数量', key: 'inspectionPassNum', minWidth: 116 },
        { title: '库存数量', key: 'inventoryTotalNum', minWidth: 116 },
        {
          title: '退货数量',
          minWidth: 116,
          render: (h, { row, index }) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.tableData[index].num = value;
                this.onChangeNum(this.tableData[index]);
              },
            },
            props: {
              value: row.num,
              placeholder: '数量',
              min: 0,
              precision: 2,
              max: row.inventoryNum, // 可退数量
            },
          }),
        },
        {
          title: '单价',
          key: 'refundPrice',
          minWidth: 116,
          render: (h, { row, index }) => {
            if (!row.payableId && !row.inspectionPayableId) {
              return h('span', row.refundPrice);
            }
            return h(DtpInputNumber, {
              on: {
                'on-blur': (value) => {
                  this.tableData[index].refundPrice = value;
                  this.onChangeNum(this.tableData[index]);
                },
              },
              props: {
              value: row.refundPrice,
              placeholder: '价格',
              min: 0,
              precision: 6,
              maxlength: 12,
              ifNeedCheckAllNumber: true,
              frontDecimal: 5
              },
            })
          }
        },
        {
          title: '退货金额',
          key: 'amount',
          minWidth: 116,
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { index }) => [
            h('lk-button',
              {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.handleRemoveGoods(index);
                  },
                },
              },
              '删除'),
          ],
        },
      ],
      supplierList: [], // 供应商列表
      saveText: '保存', // status 状态 1草稿 2审核中 3审核通过 4审核未通过 （无状态）
      refundId: '', // 如果是编辑页面，传递过来的退货单id
      saveLoading: false, // 保存中提示 防止提交多次
      submitLoading: false, // 提交中提示 防止提交多次
    };
  },
  methods: {
    onChangeNum(row) {
      const refundPrice = row.refundPrice; // 含税价格
      const num = row.num; // 退货数量
      const oldAmount = row.amount;
      console.log(oldAmount);
      console.log(refundPrice);
      console.log(num);

      row.amount = utils.toFixed2(refundPrice * num);
      // debugger;
      this.formModel.amount = utils.toFixed2((Number(this.formModel.amount) + Number(row.amount) - Number(oldAmount)));
    },
    handleRemoveGoods(index) {
      const row = this.tableData[index];
      this.formModel.amount = utils.toFixed2(this.formModel.amount - row.amount);
      this.tableData.splice(index, 1);
    },
    // 供应商名称列表
    querySupplierList() {
      refund.querySupplierList().then((res) => {
        if (res.data.status === 200) {
          this.supplierList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSupplierChange(value) {
      if (this.tempSupplier) {
        this.changeSupplier = true;
      } else {
        this.tempSupplier = value;
      }
    },
    handlePurchaseTypeChange(value) {
      if (this.tempPurchaseType) {
        this.changePurchaseType = true;
      } else {
        this.tempPurchaseType = value;
      }
    },
    doChangeSupplier() {
      this.tempSupplier = this.formModel.supplierStoreId;
      this.changeSupplier = false;
      this.resetGoods();
    },
    doChangePurchaseType() {
      this.tempPurchaseType = this.formModel.purchaseType;
      this.changePurchaseType = false;
      this.resetGoods();
    },
    cancelChangeSupplier() {
      this.formModel.supplierStoreId = this.tempSupplier;
      this.changeSupplier = false;
    },
    cancelChangePurchaseType() {
      this.formModel.purchaseType = this.tempPurchaseType;
      this.changePurchaseType = false;
    },
    resetGoods() {
      this.tempGoodsList = [];
      this.goodsData = [];
      this.tableData = [];
      this.formModel.amount = 0;
    },
    save(isSubmit) {
      this.$refs.refundForm.validate((valid) => {
        if (valid) {
          if (this.tableData.length === 0) {
            this.$Message.error('请选择商品！');
            return false;
          }

          this.tableData.forEach((item) => {
            if (!item.inventoryNum) {
              this.$Message.error(`商品"${item.approvedName}"库存为零，不可退货!`);
              return false;
            }
          });
          const addParams = {
            purchaseRefund: {
              supplierStoreId: this.formModel.supplierStoreId,
              purchaseType: this.formModel.purchaseType,
              remark: this.formModel.remark,
            },
            purchaseRefundDetailList: [],
          };
          // 获取验收单号、退货数据、单价
          this.tableData.forEach((item) => {
            const refundItem = {};
            refundItem.inspectionDetailId = item.inspectionDetailId;
            refundItem.refundPrice = item.refundPrice;
            refundItem.num = item.num;
            refundItem.inventoryId = item.inventoryId;
            addParams.purchaseRefundDetailList.push(refundItem);
          });

          if (isSubmit) { // 提交
            let finalFn = refund.purchaseRefundAddAndSubmit; // 新增提交
            if (this.refundId) { // 编辑提交
              addParams.purchaseRefund.id = this.refundId;
              finalFn = refund.purchaseRefundSubmit;
            }
            this.submitLoading = true;
            finalFn(addParams).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('提交成功！');
                this.$router.push({ name: 'supplierRefund' });
              } else {
                this.$Message.error(res.data.error);
                this.submitLoading = false;
              }
            }).catch((err) => {
              this.submitLoading = false;
              utils.handleError(err);
            });
          } else { // 保存
            // eslint-disable-next-line no-lonely-if
            let finalFn = refund.purchaseRefundAdd; // 新增保存
            if (this.refundId) { // 编辑保存
              finalFn = refund.purchaseRefundEdit;
              addParams.purchaseRefund.id = this.refundId;
            }
            this.saveLoading = true;
            finalFn(addParams).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('保存成功！');
                this.$router.push({ name: 'supplierRefund' });
              } else {
                this.saveLoading = false;
                this.$Message.error(res.data.error);
              }
            }).catch((err) => {
              this.saveLoading = false;
              utils.handleError(err);
            });
          }
        } else {
          this.$Message.error('请按要求填写退货原因！');
          return false;
        }
      });
    },
    confirmGoods() {
      if (this.tempGoodsList.length > 0) {
        let amount = 0;
        this.tempGoodsList.forEach((item) => {
          item.num = item.inventoryNum; // 退货数量
          item.amount = utils.toFixed2(item.num * item.refundPrice);
          amount += Number(item.amount);
        });

        this.tableData = utils.deepClone(this.tempGoodsList);
        this.formModel.amount = utils.toFixed2(amount);
        this.addGoods = false;
      } else {
        this.$Message.error('请选择要退货的商品！');
      }
    },
    handleAdd() {
      if (!this.formModel.supplierStoreId) {
        this.$Message.error('请先选择供应商！');
        return;
      }
      this.tempGoodsList = utils.deepClone(this.tableData);
      this.queryParams = {};
      this.goodsPage = {
        page: 1,
        size: 10,
        count: 0,
      };
      this.goodsData = [];
      this.addGoods = true;
      this.handleSearch();
    },
    handleSearch() {
      this.goodsPage.page = 1;
      this.goodsPage.size = 10;
      this.goodsParams = utils.deepClone(this.queryParams);
      this.getGoodsData();
    },
    handleTempSelect(selection, row) {
      // 多选改单选
      this.goodsData.forEach((item) => {
        if (item.inventoryId !== row.inventoryId) {
          this.$nextTick(() => {
            this.$set(item, '_checked', false);
          });
        } else {
          this.$set(item, '_checked', true);
        }
      });
      if (!this.selectedTempGoodsIds.includes(row.inventoryId)) {
        this.tempGoodsList = [];
        this.tempGoodsList.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoodsList.forEach((item, index) => {
        if (item.inventoryId === row.inventoryId) {
          this.tempGoodsList.splice(index, 1);
        }
      });
    },
    handleModalCancel() {
      this.addGoods = false;
    },
    handleGoodsPage(val) {
      this.goodsPage.page = val;
      this.getGoodsData();
    },
    handleGoodsSize(val) {
      this.goodsPage.size = val;
      this.getGoodsData();
    },
    // 获取回显信息
    getPurchaseRefundInfo(id) {
      refund.purchaseRefundInfo({ purchaseRefundId: id }).then((res) => {
        if (res.data.status === 200) {
          const { purchaseRefund, purchaseRefundDetailList } = res.data.data;
          purchaseRefundDetailList.forEach((item) => {
            item.inventoryNum = item.num; // 回显退货数量
          });
          this.tableData = purchaseRefundDetailList;
          this.tempSupplier = purchaseRefund.supplierStoreId;
          this.formModel.supplierStoreId = purchaseRefund.supplierStoreId;
          this.formModel.purchaseType = purchaseRefund.purchaseType;
          this.formModel.remark = purchaseRefund.remark;
          this.formModel.amount = purchaseRefund.amount;
          if (purchaseRefund.status === 4) { // 审核未通过 只能提交
            this.saveText = '';
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    // 退回商品
    getGoodsData() {
      this.goodsParams.page = this.goodsPage.page;
      this.goodsParams.size = this.goodsPage.size;
      this.goodsParams.supplierId = this.formModel.supplierStoreId;
      this.goodsParams.purchaseType = this.formModel.purchaseType;
      // if (this.goodsParams.inspectionTime) {
      //   this.goodsParams.inspectionTime = utils.toTimestamp(this.goodsParams.inspectionTime);
      // }
      this.loading = true;
		  this.$store.commit('setDisableLoading', true);
      refund.queryRefundGoods(this.goodsParams).then((res) => {
        if (res.data.status === 200) {
          this.goodsData = [];
          this.goodsPage.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            let result = {};
            result = item.purchaseRefundDetail;
            result.inspectionTime = utils.exchangeTime(result.inspectionTime);
            result.inventoryNum = item.inventoryNum || 0;
            result.inventoryId = item.inventoryId;
            // TODO：wxr 已经选中的列表和临时选中的列表
            // result._disabled = this.selectedGoodsIds.includes(result.inspectionDetailId) || (result.inventoryNum === 0);
            // const isChecked = this.selectedGoodsIds.includes(result.inspectionDetailId) || this.selectedTempGoodsIds.includes(result.inspectionDetailId);
            // result._checked = isChecked;
            result.expiryDate = utils.exchangeTime(result.expiryDate);
            result.purchaseTime = utils.exchangeTime(result.purchaseTime);
            this.goodsData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
		    this.loading = false;
      }).catch((err) => {
		    this.loading = false;
        utils.handleError(err);
      });
    },
    clearQueryParams() {
      this.queryParams.nameMix = '';
      // this.queryParams.approvedDrugName = '';
      this.queryParams.inspectionTime = null;
    },
  },
  created() {
    this.querySupplierList();
    this.refundId = this.$route.params.id;
    if (this.refundId) {
      this.getPurchaseRefundInfo(this.$route.params.id);
    }
  },
};
</script>
<style lang="less" >
.addContainer {
  position: relative;
  th:first-child {
    .ivu-checkbox-inner{
      display: none;
    }
  }
  .ivu-checkbox-inner {
    border-radius:50%;
  }
}
.FormatTable{
  // overflow: auto;
  overflow-x: auto;
  // border: 1px solid #eee;
  table{
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #eee;

    }

    tr{
      height: 46px
    }
    td{
      border: 1px solid #dedede;
      min-width: 110px;
      padding: 0 13px;

    }
    thead{
      background: #fafafa;
      font-weight: 500
      }

    }
</style>
